module.exports = __webpack_public_path__ + "static/media/card-content-file.7e98c217.svg";